var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.payload)?_c('div',[_c('link-entity',{attrs:{"payload":_vm.payload.company,"additional_data":_vm.additional_data}}),_c('p',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.payload.position_title))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }